// extracted by mini-css-extract-plugin
module.exports = {"root":"tweet-container_root__0rJLq","article":"tweet-container_article__0ERPK"};